// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/neon/css/bootstrap.css
// module id = 486
// module chunks = 0